import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ChargerInfo from './pages/ChargerInfo/ChargerInfo';
import InvalidQRCode from './pages/InvalidQRCode/InvalidQRCode';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/cpc/:uuid" element={<ChargerInfo />} />
          <Route path="/invalid" element={<InvalidQRCode />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
